import store from '@/store';

/**
 * Check if logged in user is super admin. If not, prevent routing.
 *
 * @param to
 * @param from
 * @param next
 * @return {*}
 */
export default (to, from, next) => {
	if (check()) {
		return next();
	}

	if (!checkIsLogged()) {
		return next({ name: 'Login' });
	} else {
		return next({ name: '404' });
	}
};

/**
 * Check if logged in user is admin.
 *
 * @return {boolean}
 */
export function check() {
	const loggedIn = store.getters.getLoggedIn;
	const user = store.getters.getUser;

	return loggedIn && user?.role === 'super_admin';
}

/**
 * Check if user is logged in.
 *
 * @return {boolean}
 */
export function checkIsLogged() {
	return store.getters.getLoggedIn;
}
